import axios from 'axios'
//登录
export async function login(data) {
  return axios.post("/index/user/login", data)
}
//验证登录
export async function verifyLogin(data) {
  axios.defaults.headers.common.token = localStorage.getItem("token") && localStorage.getItem("token") != 'undefined' ? localStorage.getItem("token") : ''
  return axios.post("/index/user/verifyLogin",data)
}
//用户详情
export async function info() {
  axios.headers = {
    token: localStorage.getItem("token") && localStorage.getItem("token") != 'undefined' ? localStorage.getItem("token") : ''
  }
  return axios.post("/index/user/info")
}



// 忘记密码
export async function modifyPwd() {
  return axios.post("/index/user/modifyPwd",)
}
// 用户信息
export async function changeInfo(form) {
  return axios.post("/index/user/changeInfo", form)
}
// export async function uploadImg(imageUrl) {
//   return axios.post("", imageUrl)
// }

// export async function addUser(req,res,next) {
// 	return axios.post('',(req,res,next))
// }

// 获取验证码
export async function getRegisterPhoneVerifyCode(data) {
	return axios.post('/index/getRegisterPhoneVerifyCode',data)
}


export async function getQrcode(data){
  return axios.post('/index/article/phpqrcode',data)
}


// WEBPACK FOOTER //
// ./src/api/user.js